import { Divider, FormGroup, List, ListItem, ListItemText, ListSubheader, Popover } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { inputValidation } from "../../helpers/commonHelpers";
import { useGeneralPairing } from "../../providers/GeneralPairing";
import './ContextMenu.scss';
import { CSVLink } from "react-csv";
import { getFormattedData } from "../../helpers/getFormattedDataForExport";


export default function ContextMenu({
    menuAnchorEl=null,
    handleMoveToCategory,
    handleMoveCategory,
    handleOptionsClose,
    setNewCategoryName,
    dataList,
    newCategoryName,
    setOpen = f => f,
    currentCategory={} as any,
    handleNameChange,
    colVisibility
}) {
    const generalPairingContext = useGeneralPairing();
    const [toggleShowEditName, setToggleShowEditName] = useState(false);
    const [exportGrid, setToggleExportGrid] = useState(false);
    const [error, setError] = useState(false);
    const [errorMax, setErrorMax] = useState(false);
    const { t } = useTranslation();

    const headers = [
      { label: "Pairing ID", key: "pairingId" }, 
      { label: "Days", key: "days" },
      { label: "Credit", key: "credit" }, 
      { label: "Route", key: "route" },
      { label: "On Duty", key: "onduty" },
      { label: "Off Duty", key: "offduty" },
      { label: "Hrs/Day", key: "hoursPerDay" },
      { label: "Expenses", key: "expenses" },
      { label: "Dates", key: "dates" }, 
      { label: "TAFB", key: "tafb" },
      { label: "EFF", key: "eff" },
      { label: "Flt#", key: "fltNo" },
      { label: "Day Credit", key: "daycredit" },
      { label: "Night Credit", key: "nightcredit" },
      { label: "Oseas Credit", key: "overseasCredit" },
      { label: "DH Credit", key: "dhCredit" },
      { label: "Sectors", key: "sectors" },
      { label: "Occurs", key: "occurs" },
      { label: "Pair Type", key: "pairType" },
    ];

    let keys = Object.keys(colVisibility);
    const filtered = keys.filter((key) => colVisibility[key])

    const handleValidation = (e) => {
      if (!inputValidation(e.target.value.trim())) {
        setError(true);
        setErrorMax(false);
      }else if (e.target.value.length >= e.target.maxLength) {
        setErrorMax(true);
        setError(false);
      }else {
        setError(false);
        setErrorMax(false);
        setNewCategoryName(e.target.value.trim());
      }
    }


    const DownloadExcel = (props) => {
      const exportBtnRef = useRef<HTMLDivElement>(null);
      useEffect(() => {
        exportBtnRef.current?.click();
        setToggleExportGrid(false);
        handleOptionsClose();
      }, [exportBtnRef]);
      
      return (
        <CSVLink {...props}>
          <span ref={exportBtnRef} />
        </CSVLink>
      )
    }
  
    return (
        <Popover className='options-on-pairing-row' open={!!menuAnchorEl} anchorEl={menuAnchorEl} onClose={()=>{
          setToggleShowEditName(false);
          setToggleExportGrid(false);
          setError(false);
          setErrorMax(false);
          setNewCategoryName('');
          handleOptionsClose();
        }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <List component="nav" aria-label="">
              {currentCategory.isHeader ?
              <ListItem button>
                <ListItemText primary="Edit name" onClick={() => setToggleShowEditName(true)}/>
              </ListItem> : ''}
              {toggleShowEditName ? 
                <ListItem>
                  <ListItemText className='edit-category-input-container'>
                      <FormGroup className="edit-category-input-form">
                          <input type ="text"
                              className = { error || errorMax ? 'category-text text-error' : 'category-text'}
                              aria-describedby="category-name-error"
                              onKeyUp={(e) => handleValidation(e)} minLength = {0} maxLength = {31}
                          />
                          {error || errorMax ? <button disabled className='diabled-edit-category-input-btn' onClick={() => handleNameChange()}>Done</button> : <button className='edit-category-input-btn' onClick={() => handleNameChange()}>Done</button>}                      
                      </FormGroup>
                      <div id="category-name-error" className="category-name-error">
                        {error && <><i className='icon-circle-flight' /><span className='edit-category-name'>{t('pairingList.errorCategoryName')}</span></>}
                        {errorMax && <><i className='icon-circle-flight' /><span className='edit-category-name'>{t('editTableColumns.preset-max-error')}</span></>}
                        </div>
                  </ListItemText>
                </ListItem>
              : ''}
              {currentCategory && !currentCategory?.isTop ? <ListItem button>
                <ListItemText primary="Move up" onClick={() => handleMoveCategory(true)} />
              </ListItem> : ''}
              {currentCategory && !currentCategory?.isBottom ? <ListItem button>
                <ListItemText primary="Move down" onClick={() => handleMoveCategory(false)} />
              </ListItem> : ''}
              {!currentCategory.isHeader && generalPairingContext.list.length >= 2 ?
                <>
                <ListSubheader>Move to:</ListSubheader>
                {generalPairingContext.list.filter(f => f.name !== currentCategory.name).map((item, index) =>
                  <ListItem key={`${index}-${currentCategory.isHeader ? 'header' : 'favorite'}`} button>
                      <ListItemText onClick={() => handleMoveToCategory(item)} primary={item.name} />
                  </ListItem>)}
                <Divider className='list-separator' />
                </>
                : ''}
                <ListItem button>
                  <ListItemText primary={currentCategory.isHeader ? 'Export category'  : ''} onClick={() => setToggleExportGrid(true)}/> 
                </ListItem>
                { currentCategory.isHeader ?  <Divider className='list-separator' /> : '' }   
                { exportGrid &&
                    <DownloadExcel filename={"my-ACcess.csv"} data={getFormattedData(currentCategory.pairingList)} headers={headers.filter(item => filtered.includes(item.key))} target="_blank" />
                  }
                <ListItem button>
                    <ListItemText primary={currentCategory.isHeader ? 'Delete category' : 'Delete pairing'} onClick={() => setOpen(true)} />
                </ListItem>
            </List>
        </Popover>
    );
}